import React from 'react'
import { Link } from 'react-router-dom'
import * as routes from './routes'
import * as actions from './actions'
import { connect } from 'react-redux'
import ReactGA from 'react-ga'


const SignOutLink = ({ clearLoginData }) =>
  <Link className="nav-a" onClick={() => {
    clearLoginData()
    ReactGA.event({
      category: 'User',
      action: 'Signed Out'
    })
  }
  }>
    Sign Out
  </Link>

const mapDispatchToProps = dispatch => ({
  clearLoginData: () => dispatch(actions.clearLoginData())
})

export default connect(null, mapDispatchToProps)(SignOutLink)